import { createContext, useContext, useState } from 'react';

const CourseTimeContext = createContext();

export function CourseTimeProvider({ children }) {
  const [showAllTime, setShowAllTime] = useState(() => {
    try {
      return localStorage.getItem('courseFilter_showAllTime') === 'true';
    } catch {
      return false;
    }
  });

  const toggleShowAllTime = () => {
    setShowAllTime((prev) => {
      const next = !prev;
      try {
        localStorage.setItem('courseFilter_showAllTime', String(next));
      } catch {}
      return next;
    });
  };

  return (
    <CourseTimeContext.Provider value={{ showAllTime, toggleShowAllTime }}>
      {children}
    </CourseTimeContext.Provider>
  );
}

export function useCourseTime() {
  return useContext(CourseTimeContext);
}
